export default __webpack_public_path__ + "static/media/cancel.c489d9d1.svg";